import api from './api';

export const getAllNcds = () => api.get('/ncds');
export const getNcdById = (id) => api.get(`/ncds/${id}`);
export const createNcd = (data) => api.post('/ncds', data);
export const updateNcd = (id, data) => api.put(`/ncds/${id}`, data);
export const deleteNcd = (id) => api.delete(`/ncds/${id}`);
export const uploadNcdMedia = (formData) => api.post('/ncds/upload-media', formData);
